/**
 * This file is a temporary wrapper for the new React based
 * PDP (Product Details Page) to replace the legacy version
 * built with with CoffeeScript. It is used in places where
 * product details are shown as a page instead of a modal.
 */

import { Component, useEffect, useMemo } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { client } from '../../../components/rest/react-query';
import { renderApp } from './utils/utils';
import PDP_v2 from './generic/product/PDP_v2';
import configureStore from './utils/configure_store';
import { tag } from './generic/global_state/reducers';
import { SpicyTagsGetter } from './generic/global_state/getters';
import { combineReducers } from 'redux';
import { Provider, connect } from 'react-redux';
import CtaHeader from './generic/CtaHeader';
import { useRdpPdpDeepLinkRedirect } from '@hungryroot/rdp';
const store = configureStore(combineReducers({ tag }));

const PDPContainer = ({ spicyTags, product }) => {
  const { loading: redirectLoading } = useRdpPdpDeepLinkRedirect(
    'product',
    product.id
  );

  return (
    <PDP_v2 loading={redirectLoading} product={product} spicyTags={spicyTags} />
  );
};

const mapStateToProps = (state) => {
  return {
    spicyTags: state.tag.spicyTags,
  };
};

const ConnectedPDPContainer = connect(mapStateToProps, null)(PDPContainer);

class PDPPageWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      product: null,
    };

    const el = document.querySelector('#pdp-page-container');
    if (el && el.getAttribute('data-id')) {
      const productId = +el.getAttribute('data-id');
      this.state.product = { id: productId };
    }
  }

  render() {
    return (
      <Provider store={store}>
        <QueryClientProvider client={client}>
          <SpicyTagsGetter />
          {this.state.product && (
            <div id="recipe">
              <section className="recipe-page-section">
                <ConnectedPDPContainer product={this.state.product} />
              </section>
            </div>
          )}
        </QueryClientProvider>
      </Provider>
    );
  }
}

renderApp(<PDPPageWrapper />, 'pdp-page-container');
